import { useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { colors } from "../../../../theme/palette";
import { useProfileData } from "../../../../hooks/useProfileData";
import { GroupListing } from "../../../../types";
import { useGroupsListing } from "../../../../api/queries/groups/useGroupsQueries";

import NoGroupsCreatedFigure from "./NoGroupsCreatedFigure";
import GroupCard, { CreateNewGroupCard, GroupCardLoader } from "./GroupCard";
import GroupPreviewPopUp from "./GroupPreviewPopUp";

const Groups = () => {
  const { entityId } = useParams();

  const { data: entityData, isLoading: isEntityDataLoading } = useProfileData();
  const { entityId: ownEntityId } = entityData;

  const targetEntityId = entityId ? +entityId : ownEntityId;

  const { groupsListing, isGroupsListingLoading, isGroupListingHasError } = useGroupsListing(targetEntityId);

  const [isGroupPreviewPopUpOpened, setIsGroupPreviewPopUpOpened] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<GroupListing | null>(null);

  const handleClosePreviewGroupPopUp = () => {
    setIsGroupPreviewPopUpOpened(false);
    setSelectedGroup(null);
  };

  const handleOpenPreviewGroupPopUp = (group: GroupListing) => {
    setIsGroupPreviewPopUpOpened(true);
    setSelectedGroup(group);
  };

  return (
    <Box
      sx={{
        padding: "23px 16px",
        background: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        minHeight: "80vh",
        position: "relative",
        display: "flex",
        flexWrap: "wrap",
        columnGap: "41px",
        rowGap: "11px",
      }}
    >
      {isGroupsListingLoading && [...Array(3)].map((_, idx) => <GroupCardLoader key={idx} />)}
      {groupsListing?.length === 0 && <NoGroupsCreatedFigure />}
      {groupsListing && groupsListing?.length > 0 && (
        <>
          <CreateNewGroupCard />
          {groupsListing?.map((group: GroupListing) => (
            <GroupCard key={group.id} group={group} handleSeeDetailsBtn={handleOpenPreviewGroupPopUp} />
          ))}
          <GroupPreviewPopUp
            open={isGroupPreviewPopUpOpened}
            handleClose={handleClosePreviewGroupPopUp}
            group={selectedGroup}
          />
        </>
      )}
    </Box>
  );
};

export default Groups;
